import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-50" }
const _hoisted_2 = { class: "container mx-auto px-4 py-8 max-w-6xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-display-sm font-heading font-bold text-primary-800 mb-6" }, " Photo Gallery ", -1)

import PhotoGalleryVue from "@/components/photos/PhotoGallery.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(PhotoGalleryVue)
    ])
  ]))
}
}

})